/**
 * Created by Alex Aguilar on 7/6/2016.
 */
(function(){
    'use strict'

    angular
        .module('completeAir')
        .factory('timeService', [function(){
            var service = {
                convertTimeToHourMinutes: convertTimeToHourMinutes,
                convertTimeToHourMinutesZero: convertTimeToHourMinutesZero,
                calculateSumTimes: calculateSumTimes
            }
            return service;

            function convertTimeToHourMinutes(time){
                var timeSplit = time.split(':');
                return timeSplit[0] + ":" + timeSplit[1];
            }

            function convertTimeToHourMinutesZero(time){
                var timeSplit = time.split(':');
                return timeSplit[0] + ":" + timeSplit[1] + ":00";
            }

            function calculateSumTimes(timeOne, timeTwo){

                timeTwo = (timeTwo == undefined) ? "00:00:00" : timeTwo;

                var timeOneSplit = timeOne.split(":"),
                    timeTwoSplit = timeTwo.split(":");

                var sumMinutes = parseInt(timeOneSplit[1]) + parseInt(timeTwoSplit[1]),
                    sumHour = parseInt(timeOneSplit[0]) + parseInt(timeTwoSplit[0]);

                if(sumMinutes >= 60){
                    sumHour = sumHour + 1;
                    sumMinutes = sumMinutes - 60;
                }

                if(sumHour >= 24){
                    sumHour = sumHour - 24;
                }

                if(sumHour < 10){
                    sumHour = "0" + sumHour;
                }

                if(sumMinutes < 10){
                    sumMinutes = "0" + sumMinutes;
                }

                return sumHour + ":" + sumMinutes;
            }

        }]);
})();

